import type { HttpTransport } from "@common/api/transport";
import type { User, UserSettings } from "@common/types/User";

type UpdateUserSettingsParams = Partial<UserSettings> & {
  exchangeRate?: number;
};

export const createUserApi = (http: HttpTransport) => ({
  closeDashboardOnboarding: () => http.post<void>("/api/dashboard_onboarding_closure"),

  fetchCurrentUser: () => http.get<User>("/api/v1/me"),

  updateCurrentUserSettings: (userSettings: UpdateUserSettingsParams) =>
    http.patch<UserSettings>(`/api/user_settings`, { userSettings })
});
